import React from 'react';
import deleteIcon from '../icons/deleteIcon.svg'
import DeleteComponent from '../icons/DeleteComponent.svg'

const FilterListComponent = (props) => {

    const deleteHandler = (item) =>{
        props.setFilterList((prevArr) => prevArr.filter(i => i !== item))
    }


    const deleteComponentItemsHandler = (componentId) => {
        props.setFilterList((prevArr) => prevArr.filter(i => i[2] !== componentId))
    }

    return (
        <>
            {
                props.filterList && props.filterList.filter(component => component[2] !== props.albumComponentId).length ?
                <div className = 'w-100 bg-blueazur d-flex flex-wrap px-4 flex-column py-3 py-md-0 py-md-2'>
                {
                    props.filterList && props.filterList.filter(item => item[2] === props.genreComponentId) && props.filterList.filter(item => item[2] === props.genreComponentId).length ?
                    <div className='d-flex flex-column flex-md-row justify-content-start py-0 py-md-2'>
                        <div className='text-info fw-bold p-2' style={{ minWidth: '8rem' }}>
                            Genres:
                        </div>
                        <div className='d-flex flex-wrap'>
                            {props.filterList
                            .filter(item => item[2] === props.genreComponentId)
                            .map((item, i) => (
                                <div
                                key={i}
                                className='d-flex flex-row align-items-center pe-3 ps-3 ps-md-0 py-1 rounded-pill'
                                >
                                <div className='fs-sm text-info pe-2 text-wrap'>{item[1]}</div>
                                <img
                                    role='button'
                                    src={DeleteComponent}
                                    alt=''
                                    onClick={() => deleteHandler(item)}
                                />
                                </div>
                            ))}
                            <img
                                role='button'
                                src={deleteIcon}
                                alt=''
                                onClick={()=>{deleteComponentItemsHandler(props.genreComponentId)}}
                            />
                        </div>
                    </div>
                    : ""
                }
                {
                    props.filterList && props.filterList.filter(item => item[2] === props.artistComponentId) && props.filterList.filter(item => item[2] === props.artistComponentId).length ?
                    <div className='d-flex flex-column flex-md-row justify-content-start py-0 py-md-2'>
                        <div className='text-info fw-bold p-2' style={{ minWidth: '8rem' }}>
                            Artists:
                        </div>
                        <div className='d-flex flex-wrap'>
                            {props.filterList
                            .filter(item => item[2] === props.artistComponentId)
                            .map((item, i) => (
                                <div
                                key={i}
                                className='d-flex flex-row align-items-center pe-3 ps-3 ps-md-0 py-1 rounded-pill'
                                >
                                <div className='fs-sm text-info pe-2 text-wrap'>{item[1]}</div>
                                <img
                                    role='button'
                                    src={DeleteComponent}
                                    alt=''
                                    onClick={() => deleteHandler(item)}
                                />
                                </div>

                            ))}
                            <img
                                role='button'
                                src={deleteIcon}
                                alt=''
                                onClick={()=>{deleteComponentItemsHandler(props.artistComponentId)}}
                            />
                        </div>
                    </div> : ""
                }
                {
                    props.filterList && props.filterList.filter(item => item[2] === props.composerComponentId) && props.filterList.filter(item => item[2] === props.composerComponentId).length ?
                    <div className='d-flex flex-column flex-md-row justify-content-start py-0 py-md-2'>
                    <div className='text-info fw-bold p-2' style={{ minWidth: '8rem' }}>
                        Composers:
                    </div>
                    <div className='d-flex flex-wrap'>
                        {props.filterList
                        .filter(item => item[2] === props.composerComponentId)
                        .map((item, i) => (
                            <div
                            key={i}
                            className='d-flex flex-row align-items-center pe-3 ps-3 ps-md-0 py-1 rounded-pill'
                            >
                            <div className='fs-sm text-info pe-2 text-wrap'>{item[1]}</div>
                            <img
                                role='button'
                                src={DeleteComponent}
                                alt=''
                                onClick={() => deleteHandler(item)}
                            />
                            </div>
                        ))}
                        <img
                                role='button'
                                src={deleteIcon}
                                alt=''
                                onClick={()=>{deleteComponentItemsHandler(props.composerComponentId)}}
                            />
                    </div>
                    </div>
                    : ""
                }
                {
                    props.filterList && props.filterList.filter(item => item[2] === props.moodComponentId) && props.filterList.filter(item => item[2] === props.moodComponentId).length ?
                    <div className='d-flex flex-column flex-md-row justify-content-start py-0 py-md-2'>
                        <div className='text-info fw-bold p-2' style={{ minWidth: '8rem' }}>
                            Moods:
                        </div>
                        <div className='d-flex flex-wrap'>
                            {props.filterList
                            .filter(item => item[2] === props.moodComponentId)
                            .map((item, i) => (
                                <div
                                key={i}
                                className='d-flex flex-row align-items-center pe-3 ps-3 ps-md-0 py-1 rounded-pill'
                                >
                                <div className='fs-sm text-info pe-2 text-wrap'>{item[1]}</div>
                                <img
                                    role='button'
                                    src={DeleteComponent}
                                    alt=''
                                    onClick={() => deleteHandler(item)}
                                />
                                </div>
                            ))}
                            <img
                                role='button'
                                src={deleteIcon}
                                alt=''
                                onClick={()=>{deleteComponentItemsHandler(props.moodComponentId)}}
                            />
                        </div>
                    </div> : ""
                }
                {
                    props.filterList && props.filterList.filter(item => item[2] === props.tagComponentId) && props.filterList.filter(item => item[2] === props.tagComponentId).length ?
                    <div className='d-flex flex-column flex-md-row justify-content-start py-0 py-md-2'>
                        <div className='text-info fw-bold p-2' style={{ minWidth: '8rem' }}>
                            Tags:
                        </div>
                        <div className='d-flex flex-wrap'>
                            {props.filterList
                            .filter(item => item[2] === props.tagComponentId)
                            .map((item, i) => (
                                <div
                                key={i}
                                className='d-flex flex-row align-items-center pe-3 ps-3 ps-md-0 py-1 rounded-pill'
                                >
                                <div className='fs-sm text-info pe-2 text-wrap'>{item[1]}</div>
                                <img
                                    role='button'
                                    src={DeleteComponent}
                                    alt=''
                                    onClick={() => deleteHandler(item)}
                                />
                                </div>
                            ))}
                            <img
                                role='button'
                                src={deleteIcon}
                                alt=''
                                onClick={()=>{deleteComponentItemsHandler(props.tagComponentId)}}
                            />
                        </div>
                    </div> : ""
                }
                </div>  :""
            }
        </>
    );
};

export default FilterListComponent;